const TABS = ['galerie', 'carte', 'proposer', 'posters', 'shop', 'dashboard'];

function tabLabel(tab) {
  if (tab === 'proposer') return 'Proposer';
  if (tab === 'galerie') return 'Galerie';
  if (tab === 'dashboard') return 'Dashboard';
  if (tab === 'posters') return 'Posters';
  if (tab === 'shop') return 'Shop';
  if (tab === 'carte') return 'Carte';
  return tab;
}

export function createTabNavigationFeature({
  navLinks,
  mainEl,
  sections,
  animPreviewFull,
  galerieAnimFull,
  galerieEmptyEl,
  mapEl,
  hasDashboardItems,
  isDbLoaded,
  invalidateCarteMap,
  onTabEffects,
  canAccessDashboard = () => true,
}) {
  let currentTab = tabFromPath();
  let carteResizeRaf = null;

  function tabFromPath() {
    const segment = window.location.pathname.replace(/^\//, '').split('/')[0] || 'galerie';
    if (!TABS.includes(segment)) return 'galerie';
    if (segment === 'dashboard' && !canAccessDashboard()) return 'galerie';
    return segment;
  }

  function computeCarteMapHeight() {
    const headerH = document.querySelector('header')?.offsetHeight ?? 48;
    const footerH = document.querySelector('footer')?.offsetHeight ?? 60;
    return Math.max(240, window.innerHeight - headerH - footerH);
  }

  function applyCarteViewportLayout(invalidate = true) {
    if (currentTab !== 'carte') return;
    if (mapEl) mapEl.style.height = computeCarteMapHeight() + 'px';
    if (invalidate) invalidateCarteMap();
  }

  function scheduleCarteViewportLayout() {
    if (currentTab !== 'carte') return;
    if (carteResizeRaf) cancelAnimationFrame(carteResizeRaf);
    carteResizeRaf = requestAnimationFrame(() => {
      carteResizeRaf = null;
      applyCarteViewportLayout(true);
    });
  }

  function switchTab(tab, pushUrl = true) {
    if (tab === 'dashboard' && !canAccessDashboard()) {
      tab = 'galerie';
    }

    window.scrollTo(0, 0);
    currentTab = tab;
    navLinks.forEach((link) => link.classList.toggle('active', link.dataset.tab === tab));

    mainEl.classList.toggle('mode-galerie', tab === 'galerie');
    mainEl.classList.toggle('mode-dashboard', tab === 'dashboard');
    mainEl.classList.toggle('mode-carte', tab === 'carte');
    mainEl.classList.toggle('mode-proposer', tab === 'proposer');
    mainEl.classList.toggle('mode-posters', tab === 'posters');
    mainEl.classList.toggle('mode-shop', tab === 'shop');

    sections.proposer.hidden = tab !== 'proposer';
    sections.galerie.hidden = tab !== 'galerie';
    sections.dashboard.hidden = tab !== 'dashboard';
    sections.posters.hidden = tab !== 'posters';
    sections.shop.hidden = tab !== 'shop';
    sections.carte.hidden = tab !== 'carte';
    animPreviewFull.hidden = true;

    const hasItems = hasDashboardItems();
    const loaded = isDbLoaded();
    galerieAnimFull.hidden = tab !== 'galerie' || !hasItems;
    galerieEmptyEl.hidden = tab !== 'galerie' || (loaded && hasItems);
    galerieEmptyEl.classList.toggle('is-loading', !loaded);

    document.title = tabLabel(tab) + ' — Punchlines No Code';
    document.body.classList.toggle('mode-galerie-active', tab === 'galerie');
    document.body.classList.toggle('mode-carte-active', tab === 'carte');
    document.body.classList.toggle('mode-proposer-active', tab === 'proposer');

    onTabEffects({ tab, hasItems, applyCarteViewportLayout, scheduleCarteViewportLayout });

    if (pushUrl) {
      const url = tab === 'galerie' ? '/' : '/' + tab;
      history.pushState({ tab }, '', url);
    }
  }

  function bindEvents() {
    window.addEventListener('resize', scheduleCarteViewportLayout);
    window.addEventListener('orientationchange', () => {
      if (currentTab !== 'carte') return;
      setTimeout(scheduleCarteViewportLayout, 80);
    });
    window.visualViewport?.addEventListener('resize', scheduleCarteViewportLayout);

    window.addEventListener('popstate', (event) => {
      switchTab(event.state?.tab ?? tabFromPath(), false);
    });

    navLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        switchTab(link.dataset.tab);
      });
    });
  }

  function getCurrentTab() {
    return currentTab;
  }

  return {
    bindEvents,
    switchTab,
    tabFromPath,
    getCurrentTab,
    applyCarteViewportLayout,
    scheduleCarteViewportLayout,
  };
}
